import type { DatePickerProps } from '@ksyos/design-system/dist/components/date-picker';
import { DatePicker, FormGroup } from '@ksyos/design-system';
import type { FormContextProps } from '../elements/formContext';
import type { OmittedFormGroupFieldProps } from './FormGroup';
import { getValidationErrorTranslation } from '../../utils/getValidationErrorTranslation';
import { FormContextConsumer } from '../elements/formContext';
import { computeFormGroupProps } from './FormGroup';

export interface DatePickerFieldProps extends DatePickerProps {
    onDoValidate?: () => void;
}

export function computeDatePickerProps(properties: DatePickerFieldProps): DatePickerProps {
    const { isDisabled, error, color, label, maxValue, minValue, onChange, onDoValidate, size, value } = properties;

    return {
        color,
        error: getValidationErrorTranslation(error),
        isDisabled,
        label,
        maxValue,
        minValue,
        name: (properties as any).fieldKey,
        onBlur: () => {
            if (onDoValidate) {
                onDoValidate();
            }
        },
        onChange,
        size,
        value,
    };
}

export type DatePickerFormGroupFieldProps = OmittedFormGroupFieldProps & DatePickerFieldProps;

export function DatePickerFormGroupField(props: FormContextProps<DatePickerFormGroupFieldProps>) {
    return (
        <FormContextConsumer {...props}>
            {(properties: any) => (
                <FormGroup {...computeFormGroupProps(properties)}>
                    <DatePicker {...computeDatePickerProps(properties)} />
                </FormGroup>
            )}
        </FormContextConsumer>
    );
}
